export enum Role {
  administrator = 'System Administrator',
  tenant_admin = 'Tenant Administrator',
  organization_owner = 'Organization Owner',
  location_manager = 'Location Manager',
}

export default Role;
